import {
  ADD_USER_SALARY_CONDITIONS,
  GET_USER_SALARY_CONDITIONS,
  SET_USER_SALARY_CONDITIONS,
  DELETE_USER_SALARY_CONDITIONS,
  UPDATE_USER_SALARY_CONDITIONS,
  LOADER_USER_SALARY_CONDITIONS
} from "./actionTypes";

export const addUserSalaryConditions = (user_id, data) => ({
  type: ADD_USER_SALARY_CONDITIONS,
  payload: { user_id, data }
})

export const getUserSalaryConditions = (data) => ({
  type: GET_USER_SALARY_CONDITIONS,
  payload: data
})

export const setUserSalaryConditions = (data) => ({
  type: SET_USER_SALARY_CONDITIONS,
  payload: data
})

export const updateUserSalaryConditions = (user_id, id, data) => ({
  type: UPDATE_USER_SALARY_CONDITIONS,
  payload: { user_id, id, data }
})

export const deleteUserSalaryConditions = (user_id, id) => ({
  type: DELETE_USER_SALARY_CONDITIONS,
  payload: { user_id, id }
})

export const loaderUserSalaryConditions = () => ({
  type: LOADER_USER_SALARY_CONDITIONS
})
